const SEED_JUNIORS = [
  {
    id: "j1",
    name: "M. Acosta",
    role: "DevOps Junior",
    location: "Buenos Aires, AR",
    yearsOfExperience: 1,
    skills: ["bash", "git", "github actions", "docker"],
    availability: "available",
    status: "available",
    rate: "$25/h",
    bio: "Ex-backend developer transitioning to DevOps. Strong scripting + GitHub Actions.",
  },
  {
    id: "j2",
    name: "R. Pérez",
    role: "DevOps Junior",
    location: "Córdoba, AR",
    yearsOfExperience: 2,
    skills: ["terraform", "aws", "kubernetes basics", "python"],
    availability: "available",
    status: "available",
    rate: "$30/h",
    bio: "Comfortable with IaC and AWS. Looking for K8s exposure on a real engagement.",
  },
  {
    id: "j3",
    name: "L. Vázquez",
    role: "DevOps Junior",
    location: "Buenos Aires, AR",
    yearsOfExperience: 1,
    skills: ["python", "linux", "prometheus", "grafana"],
    availability: "assigned",
    status: "assigned",
    rate: "$28/h",
    bio: "Observability focus. Built dashboards in last engagement.",
  },
];

export default SEED_JUNIORS;
